import { __awaiter, __generator } from "tslib";
import { d, w } from '@tinkoff/statist-page-data';
import { SDK_VERSION } from '../constants/environment';
export var appendScript = function (src) {
    return new Promise(function (resolve, reject) {
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        script.crossOrigin = 'anonymous';
        head.appendChild(script);
        script.onload = function () { return resolve(script); };
        script.onerror = function () { return reject(new Error("error when loading ".concat(src, " script"))); };
    });
};
var isScriptExists = function (src) {
    return !!d.querySelector("script[src=\"".concat(src, "\""));
};
var getMajorVersion = function (varsion) {
    return varsion.split('.')[0];
};
export var installClientScript = function () { return __awaiter(void 0, void 0, void 0, function () {
    var majorVersion, src, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                majorVersion = getMajorVersion(SDK_VERSION);
                src = "https://statist-web-sdk.t-static.ru/v".concat(majorVersion, "/client.js");
                if (!w || isScriptExists(src))
                    return [2 /*return*/];
                return [4 /*yield*/, appendScript(src)];
            case 1:
                _a.sent();
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error(error_1 instanceof Error ? error_1.message : error_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=install.js.map